module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_02@2x-3c560ace7559532e2ab5d72a37a9e631.webp";